<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.title-signup{
  margin-top: 2%;
}

.photos{
  display: grid;
  grid-template-columns: 50% 50%;
  grid-auto-rows: 165px;
  align-items: center;
  justify-items: center;
}
.r1c1{
  grid-column: 1;
  grid-row: 1;
}
.r1c2{
  grid-column: 2;
  grid-row: 1;
}
.r2c1{
  grid-column: 1;
  grid-row: 2;
}
.r2c2{
  grid-column: 2;
  grid-row: 2;
}
.r3c1{
  grid-column: 1;
  grid-row: 3;
}
.r3c2{
  grid-column: 2;
  grid-row: 3;
}

.photo{
  width: 150px;
  height: 150px;
  border: 2px #0085FF solid;
  border-radius: 150px;
  margin: auto;
}

.plus{
  width: 150px;
  height: 150px;
  padding: 47px 0 0 3px;
  font-size: 41px;
  color: white;
  text-align: center;
}

.profile-pic{
  width: 150px;
  border-radius: 150px;
}

.has-buttons{
  height: 120px;
}

</style>

<div class="bg">
  <div class="title-signup">Add photos</div>
  
  <div class="photos">
    <div class="r1c1">
      <div class="photo">
        <img src="/i/profile-pic-01.jpg" class="profile-pic">
      </div>
    </div>
    <div class="r1c2">
      <div class="photo">
        <div class="plus">+</div>
      </div>
    </div>
    
    <div class="r2c1">
      <div class="photo">
        <div class="plus">+</div>
      </div>
    </div>
    <div class="r2c2">
      <div class="photo">
        <div class="plus">+</div>
      </div>
    </div>
    
    <div class="r3c1">
      <div class="photo">
        <div class="plus">+</div>
      </div>
    </div>
    <div class="r3c2">
      <div class="photo">
        <div class="plus">+</div>
      </div>
    </div>
  </div>
  <div class="has-buttons"></div>
  
</div>

<div class="next">
  <button on:click="{next}">Next</button>
</div>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';


function next() {
  push("/signup/profile/personal/add-interests");
}


</script>